import { ListingDto } from "./listing.dto";
import { hasPhone } from "../../api/contacts";
import { cleanAddress, coordsOf } from "../../helpers/location";
import { Listing } from "./listing.model";

export function mapListingDto(dto: ListingDto): Listing {
  // Exact point from latitude / longitude (legacy listings: address suffix).
  const raw = dto as any;
  const point = coordsOf(raw);
  const lat = point?.lat;
  const lng = point?.lng;

  return {
    id: dto.id,
    title: dto.title,
    description: dto.description,

    region: dto.region,
    type: dto.type,

    area: String(dto.area),
    price: String(dto.price),
    rooms_count: String(dto.room_count),
    image: dto.image,
    images: dto.images,

    location: {
      address: cleanAddress(dto.address),
      precision: ["pin", "address", "area"].includes(raw.location_precision) ? raw.location_precision : undefined,
      lat,
      lng,
    },
    currency: raw.currency === "KGS" ? "KGS" : "USD",
    is_negotiable: Boolean(raw.is_negotiable) || !Number(dto.price),
    district: dto.district,

    seller: {
      phone: dto.phone_number || "",
      hasPhone: hasPhone(dto),
      // The listing's own contact e-mail; the account e-mail is private (B13).
      email: dto.email || dto.user?.email || "",
      name: dto.user?.name || "",
      avatar: dto.user?.avatar,
      company_name: dto.user?.company_name || '',
      created_at: dto.user?.created_at || '',
      id: dto.user?.id,
      is_tick: dto.user?.is_tick || false,
      type: dto.user?.type,
      property_count: dto.user?.property_count || 0,
      company_address: dto.user?.company_address || '',
      company_description: dto.user?.company_description || '',
      company_link: dto.user?.company_link || '',
      company_time: dto.user?.company_time || '',
    },

    isFeatured: dto.is_premiuem,
    isPaid: dto.isPaid ?? false,
    is_top: dto.is_top ?? false,
    is_vip: dto.is_vip ?? false,
    is_urgent: dto.is_urgent ?? false,

    // Apartment details (backend columns; the page falls back to the
    // description marker for listings saved before they existed).
    floor: raw.floor ?? null,
    floors_total: raw.floors_total ?? null,
    is_corner: raw.is_corner ?? null,
    is_walk_through: raw.is_walk_through ?? null,

    createdAt: String(new Date(dto.createdat)),
    updatedAt: String(new Date(dto.updateat)),

    views: dto.views,
    status: raw.status ?? "active",
    soldAt: raw.sold_at ?? null,
    // A/B-тест фото: метка варианта для трекера (backend, см. docs/analytics-api-contract.md).
    abTest: raw.abTest ?? null,
    // category
    isLike: dto.is_like,
    video_link: dto.video_link
  };
}
